import { render, staticRenderFns } from "./RequestsFrameLayout.vue?vue&type=template&id=1e0ef2ee&scoped=true&"
import script from "./RequestsFrameLayout.vue?vue&type=script&lang=js&"
export * from "./RequestsFrameLayout.vue?vue&type=script&lang=js&"
import style0 from "./RequestsFrameLayout.vue?vue&type=style&index=0&id=1e0ef2ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ef2ee",
  null
  
)

export default component.exports